module.exports = __webpack_public_path__ + "static/img/WX20180907-003921@2x.585fa9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WX20180907-003921@2x.png
// module id = qvKU
// module chunks = 2